import { DeleteTeam } from './DeleteTeam'
import { EditAddTeam } from './EditAddTeam'
import { CommonPropsTeam, TeamActionsTypes } from './types'

export const modalsActions: Record<
  TeamActionsTypes,
  React.FC<CommonPropsTeam>
> = {
  edit: EditAddTeam,
  delete: DeleteTeam
}
